import { CorporateStatusResponseApi } from '@blank/api'
import { apiClient } from 'modules/common/http/apiClient'
import { getAuthorizationHeader } from 'modules/common/lib/api/getAuthorizationHeader'

interface Props {
  corporateId: string
  accessToken: string
}

export const fetchCorporateStatus = async ({
  corporateId,
  accessToken,
}: Props) => {
  const apiUrl = `/v1/users/corporates/${corporateId}/status`

  const { data } = await apiClient.get<CorporateStatusResponseApi>(apiUrl, {
    headers: getAuthorizationHeader(accessToken),
  })

  return data.globalStatus
}
